export default {
  "form": {
    "select": {
      "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Per favore scegli"])}
    },
    "input": {
      "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pezzo"])}
    }
  },
  "buttons": {
    "download": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Scarica istruzioni di montaggio"])},
    "watchlistAdd": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aggiungi alla lista dei preferiti"])},
    "watchlistAdded": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aggiunto alla lista dei preferiti"])},
    "email": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Richiedi ora"])}
  },
  "labels": {
    "model": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Modello"])},
    "productGroup": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gruppo di prodotto"])},
    "articleNumber": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Numero dell'articolo"])},
    "technicalNote": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nota tecnica"])}
  },
  "error": {
    "required": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["È necessario fare una selezione!"])}
  }
}